


































































































































































































































import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {checkMobile} from '../../utils/utils'
import MaterialCard from '../../materials/Card.vue'
import UserBlock from '../../../api/v2/models/user_block'
import UserForm from '../../../api/v2/forms/user_form'
import api from '../../../api/v2/api'
import {userState} from '../../stores/user'
import {headerState} from '../../stores/header'

const defaultAvt =
    '/assets/user.png'

@Component({
  components: {
    MaterialCard
  }
})
export default class MyprofileUpdate extends Vue {
  @Prop({
    default: true
  })
  showPreview: boolean = true

  @Prop({
    default: 'user_update'
  })
  mode: 'user_update' | 'guest_update' = 'user_update'

  mobile: boolean = false
  form = new UserForm()
  groups: UserBlock[] = []
  completeDialog = false
  image: any = defaultAvt 

  notifications = {
    courseUpdates: true,
    testReminders: true,
    studyReminders: false,
    achievements: true,
    pushEnabled: false
  };
  emailSettings = {
    newsletter: true,
    courseUpdates: true,
    studyReminders: false,
    promotions: false,
    frequency: 'daily'
  };
  activeSection: string = 'profile';
  errorMessageMap = new Map<string, string>()

  get user() {
    return userState.user
  }

  get isGuestUpdate() {
    return this.mode == 'guest_update'
  }

  getErrorMessageMap(key: string) {
    return this.errorMessageMap[key]
  }

  get isLoading() {
    return userState.isLoading
  }

  get schoolSetting() {
    return headerState.schoolSetting
  }

  get errorMessage() {
    return userState.errorMessage
  }

  async created() {
    if (this.$route.query.section === 'deletion') {
      this.activeSection = 'deletion'
    }
    this.mobile = checkMobile()
    this.groups = await api.userBlock.index()
  }

  uploadImage() {
    const imageInput = this.$refs.imageInput as HTMLInputElement;
    if (imageInput) {
      imageInput.click();
    }
  }

  handleImageUpload(e: any) {
    const files = e.target.files || e.dataTransfer.files
    if (!files.length) return
    this.createImage(files[0])
  }

  createImage(file: any) {
    this.form.image = file
    this.form.deleteImage = false

    const reader = new FileReader()
    reader.onload = (e) => {
      this.image = e.target.result
    }
    reader.readAsDataURL(file)
  }

  removeImage(e: any) {
    e.preventDefault()
    this.image = defaultAvt
    this.form.image = null
    this.form.deleteImage = true
  }

  mounted() {
    this.setUser()
    userState.getUser()
  }

  @Watch('user')
  setUser() {
    if (this.user) {
      this.form.name = this.user.name;
      this.form.email = this.user.email;
      this.form.userBlockId = this.user.userBlockId;
      this.image = this.user.image ? this.user.image.url : defaultAvt;
    }
  }

  setActiveSection(section: string) {
    this.activeSection = section;
  }

  async saveProfile() {
    this.completeDialog = false
    let errorMessageProfileMap = new Map<string, string>()
    let flagError = false
    if (!this.form.name || this.form.name.indexOf('guest_') != -1) {
      errorMessageProfileMap['name'] = '名前を変更してください'
      flagError = true
    }
    if (!this.form.email || this.form.email.indexOf('guest_') != -1) {
      errorMessageProfileMap['email'] = 'メールアドレスを変更してください'
      flagError = true
    }
    if (flagError) {
      this.errorMessageMap = errorMessageProfileMap
      return
    }

    if (!this.isLoading) {
      await userState.updateUser({
        userForm: this.form
      })

      if (!this.errorMessage) {
        this.completeDialog = true
      }
    }
  }

  async savePassword() {
    this.completeDialog = false
    let errorMessagePasswordMap = new Map<string, string>()
      this.errorMessageMap = errorMessagePasswordMap
    let flagError = false
    if (!this.form.password) {
      errorMessagePasswordMap['password'] = 'パスワードを入力してください'
      flagError = true
    }
    if (!this.form.newPassword) {
      errorMessagePasswordMap['newPassword'] = '新しいパスワードを入力してください'
      flagError = true
    }
    if (this.form.password && !this.form.isSamePass) {
      errorMessagePasswordMap['newPasswordConfirmation'] = 'パスワード（再入力）とパスワードの入力が一致しません'
      flagError = true
    }
    if (this.form.newPassword && this.form.newPassword.length < 8) {
      errorMessagePasswordMap['newPassword'] = 'パスワードは8文字以上で入力してください'
      flagError = true
    }
    if (flagError) {
      this.errorMessageMap = errorMessagePasswordMap
      return
    }

    if (!this.isLoading) {
      await userState.updateUser({
        userForm: this.form
      })

      if (!this.errorMessage) {
        this.completeDialog = true
      }
    }
  }

  saveNotifications() {
    alert('通知設定が更新されました')
  }

  saveEmailSettings() {
    alert('メール設定が更新されました')
  }
}
